import {
  ReadQaCampaignFunnelRun,
  StartQaCampaignFunnel,
} from '@tinct/core-api-models';
import { ApiClient } from '../api-client/api-client';

export interface StartQaCampaignFunnelParams {
  organizationId: string;
  data: StartQaCampaignFunnel;
}

export class QaCampaignsEndpoint {
  constructor(private client: ApiClient) {}

  async startQaCampaignFunnel(
    params: StartQaCampaignFunnelParams,
  ): Promise<ReadQaCampaignFunnelRun> {
    const { organizationId, data } = params;
    // The back-office has no ambient workspace, so the org-scoped header must
    // be set explicitly on this call.
    return this.client.post<ReadQaCampaignFunnelRun>(
      `/api-tools/v1/qa/organizations/${organizationId}/qa-campaign`,
      data,
      { headers: { 'X-Tinct-OrganizationId': organizationId } },
    );
  }
}
